export const cmpOpener = () => {
  const cmpOpener = [...document.querySelectorAll('.cmp-opener')]
  cmpOpener.map( (link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      window.OneTrust.ToggleInfoDisplay()
    })
  })
};